export default __webpack_public_path__ + "static/craftsman-8b65727bc93369b24e4cddec512d1f63.png";